
// local info
export class LocalInfo
{
	searchFilters: Array<LocalInfoSearchFilter>;

	constructor()
	{
		this.searchFilters = new Array<LocalInfoSearchFilter>();
	}
}

// search filters
export class LocalInfoSearchFilter
{
	name: string;
	value: string;
}

export const enum SEARCH_FILTERS
{
	// ==========================================
	// ADMIN
	// ==========================================

	// bonus
	// ==========================================

	// bonus
	BONUS_BONUS_LIST = 'BonusBonusList',

	// companies
	BONUS_COMPANIES_LIST = 'BonusCompaniesList',

	// file types
	BONUS_FILETYPES_LIST = 'BonusFileTypesList',
	BONUS_FILEGROUPS_LIST = 'BonusFileGroupsList',

	// business consultants
	BONUS_BUSINESSCONSULTANTS_LIST = 'BonusBusinessConsultantsList',

	// tags
	BONUS_TAGS_LIST = 'BonusTagsList',

	// ==========================================
	// users
	// ==========================================

	// users
	USERS_USERS_LIST = 'UsersUsersList',
	USERS_USERS_SELECTOR = 'UsersUsersSelector',

	// roles
	USERS_ROLES_LIST = 'UsersRolesList',

	// system
	// ==========================================

	// modules
	SYSTEM_MODULES_LIST = 'SystemModulesList',

	// applications
	SYSTEM_APPLICATIONS_LIST = 'SystemApplicationsList',

	// permissions
	SYSTEM_PERMISSIONS_LIST = 'SystemPermissionsList',

	// policies
	SYSTEM_POLICIES_LIST = 'SystemPoliciesList',

	// parameters
	SYSTEM_PARAMETERS_LIST = 'SystemParametersList',

	// logs
	SYSTEM_LOGS_LIST = 'SystemLogsList',

	// ==========================================
	// WEBAPP
	// ==========================================

	// professionals
	// ==========================================

	// bonus list
	PROFESSIONALS_BONUS_LIST = 'ProfessionalsBonusList'
}